export default "__VITE_ASSET__XLWFdX8o__"